module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/california-6a499317c8b135fd1037c49163153ddb.jpg";